import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Input from '../input'
import emitOnBlur from '@cred/react-analytics/hoc/emitOnBlur'
import emitOnKeyPress from '@cred/react-analytics/hoc/emitOnKeyPress'
import {FormField} from '@cred/react-form-field'
import NumberFormat from 'react-number-format'
import {Label} from '@cred/react-label'
import defaultStyles from './themes/default/styles.module.scss'
import credible3 from './themes/credible3/styles.module.scss'
import thebalance1 from './themes/thebalance1/styles.module.scss'
import investopedia1 from './themes/investopedia1/styles.module.scss'
import forbes1 from './themes/forbes1/styles.module.scss'
import withStyles from '@cred/react-theme'
import { moneyInputWarning } from '@cred/shared/validations'

/**
 * @visibleName Money Input
 */
class MoneyInput extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    id: PropTypes.string,
    placeholder: PropTypes.string,
    icon: PropTypes.bool,
    validate: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.func)]),
    styles: PropTypes.object,
    warningType: PropTypes.string
  }

  static defaultProps = {
    label: '',
    styles: defaultStyles
  }

  static displayName = 'MoneyInput'

  render() {
    const {className, name, label, validate, styles, placeholder, ...props} = this.props

    return (
      <div className={className}>
        <Input
          type="text" 
          name={`${name}`}
          component={inputWithAnalytics}
          validate={validate}
          placeholder={placeholder}
          inputStyles={styles}
          label={label}
          {...props}/>
      </div>
    )
  }
}

const inputComponent = ({input, label, meta, id, getInputRef, decimalScale = 0, theme, placeholder = '$', icon = true, inputStyles, warningType}) =>
  <FormField status={meta} error={meta.error} value={input.value} label={label} icon={icon} theme={theme} warning={moneyInputWarning(input.value, warningType)}>
    <div className={inputStyles.inputContainer}>
      <div className={inputStyles.dollarSign}><i className="cred-icon icon-money-dollar"></i></div>
      <div className={inputStyles.input}>
        <NumberFormat
          isAllowed={({floatValue}) => floatValue === undefined || floatValue <= 9999999}
          thousandSeparator={true}
          prefix="$"
          decimalScale={decimalScale}
          allowNegative={false}
          type="tel"
          placeholder={placeholder}
          maxLength="13"
          id={id || input.name}
          getInputRef={getInputRef}
          {...input}
        />
      </div>
      <Label className={inputStyles.label} htmlFor={id || input.name}>{label}</Label>
    </div>
  </FormField>,
  inputWithAnalytics = /*#__PURE__*/ emitOnKeyPress(emitOnBlur(inputComponent))

export {MoneyInput as MoneyInputNoHoc, inputComponent}

export default /*#__PURE__*/ withStyles(
  defaultStyles, {
    credible3,
    thebalance1,
    investopedia1,
    forbes1
  }
)(MoneyInput)
